import { render } from "./IndexCounters.vue?vue&type=template&id=3c1ce721"
import script from "./IndexCounters.vue?vue&type=script&lang=js"
export * from "./IndexCounters.vue?vue&type=script&lang=js"

import exportComponent from "/opt/microsoft-academy/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__